import { useEffect, useState } from "react";

import styles from "./topicSelectionPage.module.css";
import AppBar from "../../components/appBar/appBar";
import AbortGame from "../../components/abortGame/abortGame";
import ImgBuilder from "../../assets/ImgBuilder";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from '../../functions/setGetLanguage';
import { useUserData } from '../../functions/updateUserData';
import { getTopics } from "../../api/api";

const TopicSelectionPage = () => {
  const [topics, setTopics] = useState(null);
  const { userData, setUserData } = useUserData();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const topicsData = await getTopics(userData.tokens["access_token"]);
        setTopics(topicsData);
      } catch (error) {
        console.error("Failed to fetch topics:", error);
      }
    };

    fetchTopics();
  }, [userData]);


  const navigate = useNavigate();
  const [topicIdChosen, setTopicIdChosen] = useState(null);
  const [topicIdChosenActivated, setTopicIdChosenActivated] = useState(false);

  // language
  const { language } = useLanguage();
 

  // for the transition to play
  const DELAY = 350;

  const handleClick = (gameType) => {
    if (topicIdChosen){
      setUserData(prev => ({
        ...prev,
        "topic_id": topicIdChosen
      })); 
      setTopicIdChosenActivated(true)
      setTimeout(() => navigate("/explanation"), DELAY);
    }
  };

  const chooseMode = (choice) => {
    if (choice === topicIdChosen){
      setTopicIdChosen(null)
    } else{
      setTopicIdChosen(choice)
    }
  };

  return (

    <div className={styles.modeSeletorContainer}>
      <AppBar />
      <AbortGame />
      <img alt="bg" src={ImgBuilder.sbBackground} className={styles.bgImg}/>
      {topics &&
      <>
      <div className={styles.containerInner}>
        <div className={`${styles.boxModeSelector} ${topicIdChosenActivated ? styles.disappearBox : ''}`}>
          <p className={styles.callToActionBox}>
            {t("topic_selection.title")}
          </p>
          <p className={styles.subCallToActionBox}>
            {t("topic_selection.subtitle")}
          </p>
          <div className={styles.gameModesContainer}>
            {topics && topics.map((item, idx) =>
              <div key={idx} onClick={() => chooseMode(item.id)} className={`${styles.optionGame} ${item.id === topicIdChosen ? styles.activeMode : ""}`}>
                <div className={`${styles.circleSelected}`}></div>
                <img alt={`option${idx}`} className={styles.imageOptionGame} src={ImgBuilder[`topic${item.id}`]}/>
                <p className={styles.textOptionGame}>{item[`name${language}`]}</p>
              </div>
            )}

          </div>

        </div>
      </div>


      <div className={`${styles.buttonsContainer} 
      ${topicIdChosen ? styles.buttonContainerActivate : ""}
      ${topicIdChosenActivated ? styles.disappearBox : ''}`}>
        <button onClick={() => handleClick()} className={styles.button}>
          {t("topic_selection.button")}
        </button>
      </div>
      </>
      }

    </div>
    
  );
};
export default TopicSelectionPage;
